"use client";

import clsx from "clsx";

interface VoiceFilterChipProps {
  label: string;
  selected: boolean;
  onToggle: () => void;
}

export default function VoiceFilterChip({
  label,
  selected,
  onToggle,
}: Readonly<VoiceFilterChipProps>) {
  return (
    <button
      type="button"
      aria-pressed={selected}
      onClick={onToggle}
      className={clsx(
        "px-3 py-1.5 text-sm rounded-full border transition-colors cursor-pointer whitespace-nowrap",
        selected
          ? "border-primary text-primary"
          : "border-border text-foreground hover:border-primary/60"
      )}
    >
      {label}
    </button>
  );
}
